// extracted by mini-css-extract-plugin
export default {"errorPage":"ErrorPage_errorPage__dfz9c","text":"ErrorPage_text__s7JUW","pagePc":"ErrorPage_pagePc__iBJVb"};